import {
  ICrmMarketingList,
  MemberType,
  StateType,
} from '../../../shared/interfaces/crm-marketing-list.interface';
import {
  IMarketingListApi,
  IMembersListApi,
} from '../interfaces/api/marketing-list.interface';

type MemberMapType = { [key: number]: MemberType };
type StateMapType = { [key: number]: StateType };

export const marketingListApiMapper = (
  list: IMarketingListApi,
): ICrmMarketingList => {
  const memberTypeMap: MemberMapType = {
    1: 'account',
    2: 'contact',
    4: 'lead',
  };

  const stateMap: StateMapType = {
    0: 'Active',
    1: 'Inactive',
  };

  return {
    listId: list.listid,
    createdOn: list.createdon,
    listName: list.listname,
    memberCount: list.membercount,
    memberType: memberTypeMap[list.membertype],
    state: stateMap[list.statecode],
    type: list.type ? 'Dynamic' : 'Static',
    query: list.query,
  };
};

export const membersListApiMapper = (list: IMembersListApi): string => {
  return list._entityid_value;
};
